import "./Card.scss";
function Card({ imgSrc, number, title, lightColor, darkColor, underline }) {
  return (
    <div
      className="m-2 py-4 text-light d-flex justify-content-evenly align-items-center Card"
      style={{
        backgroundImage: `linear-gradient(to left, ${lightColor} , ${darkColor})`,
        borderRadius: "10px",
      }}
    >
      <div className="text-center">
        <div className="fs-5 mb-3">{title}</div>
        <div
          className={`${underline && "border-bottom"} border-3 d-inline fs-3`}
        >
          {number}
        </div>
      </div>
      <img src={`${imgSrc}`} className="image" />
    </div>
  );
}

export default Card;
